var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Data } from './data';
import { Discount } from './discount';
var Reward = /** @class */ (function (_super) {
    __extends(Reward, _super);
    function Reward() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "Reward";
        return _this;
    }
    Reward.toRewardData = function (reward) {
        var json = {};
        json["id"] = reward.id;
        json["name"] = reward.name;
        json["hint"] = reward.hint;
        json["published"] = reward.published;
        json["backendId"] = reward.backendId;
        json["price"] = reward.price;
        if (reward.discount) {
            json["discount"] = Discount.toDiscountData(reward.discount);
        }
        return json;
    };
    Reward.prototype.toProperty = function (name, value) {
        if (name == "discount") {
            return Data.toData(Discount, value);
        }
        return value;
    };
    // 判断在当前的order下是否满足使用reward的条件(reward flow：用佐offer, 相当于apply 一次 discount)
    // Whether to meet the conditions of using reward with Order
    Reward.prototype.isReawardSatisfied = function (order) {
        var ok = true;
        var promo = this.findPromo_discount(order);
        promo && this.discount && this.discount.conditions.forEach(function (c) {
            if (!c.isSatisfied(order, promo))
                ok = false;
        });
        return ok;
    };
    // 从所有的 discounts 里找到当前 reward 对应的 discount
    Reward.prototype.findPromo_discount = function (order) {
        var _this = this;
        // order.promotions: original discounts_all information
        if (!order || !order.promotions || order.promotions.length === 0)
            return null;
        var promos = order.promotions.filter(function (pro) {
            return _this.discount && pro && _this.discount.id === pro.id;
        });
        var promo = promos && promos[0];
        if (!promo) {
            console.log('找不到reward 对应的discount in store.menu.discounts(brand.discounts)');
        }
        return promo;
    };
    return Reward;
}(Data));
export { Reward };
//# sourceMappingURL=reward.js.map